import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Country from "./Country";
import ProductVariation from "./ProductVariation";
import moment from "moment";
import { date_time_format } from "../../../assets/js/mcn-helpers";
import Model from "./Model";
export class Inventory extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'inventory_id',
      fieldTitle: null,
      placeholder: null,
      content: null
    });
    _defineProperty(this, "InventoryId", {
      fieldName: 'inventory_id',
      fieldTitle: null,
      placeholder: null,
      content: null
    });
    _defineProperty(this, "Variation", {
      fieldName: 'variation',
      model: ProductVariation,
      content: null
    });
    _defineProperty(this, "InventoryQuantity", {
      fieldName: 'inventory_quantity',
      fieldTitle: null,
      placeholder: null,
      content: null
    });
    _defineProperty(this, "InventoryCountryID", {
      fieldName: 'country_id',
      content: null
    });
    _defineProperty(this, "InventoryProductID", {
      fieldName: 'product_id',
      content: null
    });
    _defineProperty(this, "InventoryCountry", {
      fieldName: 'inventory_country',
      model: Country,
      fieldTitle: null,
      placeholder: null,
      content: {}
    });
    _defineProperty(this, "country", {
      fieldName: 'inventory_country',
      model: Country,
      fieldTitle: null,
      placeholder: null,
      content: {}
    });
    _defineProperty(this, "InventoryCost", {
      fieldName: 'inventory_cost',
      fieldTitle: null,
      placeholder: null,
      content: null
    });
    _defineProperty(this, "InventoryType", {
      fieldName: 'inventory_type',
      fieldTitle: 'Inventory Type',
      placeholder: null,
      content: null
    });
    _defineProperty(this, "InventoryDate", {
      fieldName: 'created_at',
      content: null
    });
    _defineProperty(this, "InventoryDeleteDate", {
      fieldName: 'deleted_at',
      content: null
    });
    _defineProperty(this, "InventoryTotalQunatity", {
      fieldName: 'inventory_total_quantity',
      content: null
    });
    _defineProperty(this, "InventoryQunatitySum", {
      fieldName: 'inventory_quantity_sum',
      content: null
    });
    _defineProperty(this, "InventoryCostSum", {
      fieldName: 'inventory_cost_sum',
      content: null
    });
    _defineProperty(this, "InventoryUnitaryCostSum", {
      fieldName: 'inventory_unitary_cost_sum',
      content: null
    });
    _defineProperty(this, "InventoryUnitaryCost", {
      fieldName: 'inventory_unitary_cost',
      content: null
    });
    _defineProperty(this, "InventoryRemainingQuantity", {
      fieldName: 'inventory_remaining_quantity',
      content: null
    });
    _defineProperty(this, "createdAt", {
      fieldName: 'created_at',
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getCreationDate() {
    return this.createdAt.content;
  }
  getMomentCreationDate() {
    return moment(this.getCreationDate()).format(date_time_format);
  }
  getVariation() {
    return this.Variation.content;
  }
  getCost() {
    return this.InventoryCost.content;
  }
  getUnitaryCost() {
    return this.InventoryUnitaryCost.content;
  }
  getVariationSku() {
    let variation = this.getVariation();
    return variation instanceof ProductVariation ? variation.getSku() : null;
  }
  getQuantity() {
    return this.InventoryQuantity.content;
  }
  getCountry() {
    return this.country.content;
  }
}
_defineProperty(Inventory, "PRIVATE_TYPE", 'private');
_defineProperty(Inventory, "OUTSOURCED_TYPE", 'outsourced');
export default Inventory;